export default __webpack_public_path__ + "static/media/438.c740f181.gif";